import { render, staticRenderFns } from "./MyProjectsContractBaseData.vue?vue&type=template&id=27c2defc&scoped=true"
import script from "./MyProjectsContractBaseData.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContractBaseData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsContractBaseData.vue?vue&type=style&index=0&id=27c2defc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2defc",
  null
  
)

export default component.exports